// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gallery-block__gallery[data-v-8391e088]{margin-left:auto;margin-right:auto}.gallery-block__2-up[data-v-8391e088]{grid-gap:3em;display:grid;grid-auto-rows:1fr;grid-template-columns:1fr 1fr}.gallery-block__2-up .gallery-block__1-up[data-v-8391e088]{position:relative}.gallery-block__media[data-v-8391e088]{display:block;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
